module.exports = {
    "dismiss": `Dispensar`
};


//# sourceMappingURL=pt-PT.main.js.map
